import Row from '../Row';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Clear, Item } from './components';

const Filters = ({
  marg,
  options = [],
  onChange = () => {},
  onSubChange = () => {},
  refreshing
}) => {
  const [rendered, setRendered] = useState(false);
  const [selected, setSelected] = useState(null);
  const [subSelected, setSubSelected] = useState([]);
  const [subOptions, setSubOptions] = useState([]);
  const isMobile = useSelector((state) => state.appState.isMobile);

  useEffect(() => {
    setRendered(true);
    if (!rendered || refreshing) return;
    handleClear();
  }, [refreshing]);

  function handleClear() {
    setSelected(null);
    setSubOptions([]);
    setSubSelected([]);
    onChange(null);
    onSubChange(null);
  }

  function handleSelect(item) {
    if (selected?.value === item.value) return handleClear();

    setSelected(item);
    onChange(item);
    if (item.subOptions?.length) setSubOptions(item.subOptions);
  }

  function handleSubSelect(item) {
    if (subSelected?.length && subSelected.includes(item?.value)) {
      const newSelected = subSelected.filter((x) => x !== item.value);
      setSubSelected(newSelected);
      return onChange({ type: selected.value, values: newSelected });
      // return onSubChange({ type: selected.value, values: newSelected })
    }

    const newSelected = [...subSelected, item?.value];
    setSubSelected(newSelected);
    onSubChange({ type: selected.value, values: newSelected });
  }

  if (!options.length) return null;

  return (
    <Row
      marg={marg}
      noFlex
      scrollX
      style={{ scrollbarWidth: 'thin' }}
      pad={isMobile && '0 0 0 16px'}
      wid={isMobile ? 'calc(100% - 16px)' : 'auto'}
    >
      <Clear handleClear={handleClear} show={selected} />

      {options.map((x, i) => (
        <Item
          key={i}
          item={x}
          isSelected={selected && selected.value === x.value}
          dontShow={selected && selected.value !== x.value}
          onClick={() => handleSelect(x)}
        />
      ))}

      {subOptions?.map((x, i) => (
        <Item
          key={i}
          item={x}
          isSelected={subSelected?.length && subSelected?.includes(x.value)}
          onClick={() => handleSubSelect(x)}
          isSub
        />
      ))}
    </Row>
  );
};

export default Filters;
